import { render, staticRenderFns } from "./DetailsData.vue?vue&type=template&id=3b178660"
import script from "./DetailsData.vue?vue&type=script&lang=js"
export * from "./DetailsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports